import { Column } from "@ant-design/charts";
import type { CardProps } from "antd";
import { Button, Card } from "antd";
import type { FC } from "react";
import { useNavigate } from "react-router";

import type { TerminalStatusDataDto } from "../types/Dashboard";

interface TerminalStatusCardProps extends CardProps {
    data: TerminalStatusDataDto[];
}

/**
 * TerminalStatusCard - Stacked column chart showing terminal status (Updated/In Progress/Failed) over a week
 */
export const TerminalStatusCard: FC<TerminalStatusCardProps> = ({ data, ...cardProps }) => {
    const navigate = useNavigate();
    const chartData = data;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config: any = {
        data: chartData,
        xField: "day",
        yField: "value",
        colorField: "status",
        stackField: "status",
        color: ["#f5222d", "#1890ff", "#52c41a"], // Solid Red (Failed), Solid Blue (In Progress), Solid Green (Updated)
        stack: true,
        label: {
            position: "top" as const,
            offset: 10,
            style: {
                fill: "transparent",
            },
        },
        interactions: [
            {
                type: "active-region",
                enable: false,
            },
        ],
        columnBackground: {
            style: {
                fill: "rgba(0,0,0,0.1)",
            },
        },
        legend: {
            position: "bottom" as const,
        },
    };

    const handleSeeAll = () => {
        navigate("/terminal-versions");
    };

    return (
        <Card
            title="Terminal Status"
            extra={<Button onClick={handleSeeAll}>See all</Button>}
            {...cardProps}
            style={{ backgroundColor: "#FFFFFF", height: "100%", ...cardProps.style }}
        >
            <Column {...config} />
        </Card>
    );
};
